import { HTMLAttributes } from "react";
import styled from "styled-components";

export default styled(function (
  props: Omit<HTMLAttributes<HTMLDivElement>, "children">
) {
  return (
    <footer {...props}>
      <p>
        &copy; {new Date().getFullYear()} NAF v{process.env.REACT_APP_VERSION}
      </p>
    </footer>
  );
})`
  p {
    margin: 0;
    background-color: white;
    padding: 0.5em 1em;
    ${({ theme }) => theme.fontStyle.ui.tiny};
  }
`;
